import { useTranslation } from "@/hooks/useTranslation";
import OrdersAddDialog from "@/pages/orders/OrdersAddDialog/Index";
import { addOrderDialogAtom, addOrderSideAtom } from "@/store/order";
import { Button, Icon } from "@st-marketplace/ui";
import { useAtom, useSetAtom } from "jotai";
import type { FC } from "react";

export const AddOrderButton: FC<{ side?: "buy" | "sell"; compact?: boolean }> =
	({ side = "buy", compact = false }) => {
		const { t } = useTranslation();
		const setSide = useSetAtom(addOrderSideAtom);
		const openAddOrder = useSetAtom(addOrderDialogAtom);

		return (
			<Button
				type="button"
				color="primary"
				size="sm"
				startIcon={<Icon name="add-line" />}
				onClick={() => {
					setSide(side);
					openAddOrder(true);
				}}
			>
				{t(
					compact
						? `order.${side}Coin`
						: `order.add${side === "buy" ? "Buy" : "Sell"}`,
				)}
			</Button>
		);
	};

/** Mounted once per dashboard; the heavy dialog only loads once it is opened. */
export const AddOrderDialogHost: FC = () => {
	const [side, setSide] = useAtom(addOrderSideAtom);
	const [open, setOpen] = useAtom(addOrderDialogAtom);
	return open ? (
		<OrdersAddDialog
			side={side}
			open
			onClose={() => {
				setOpen(false);
				setSide("buy");
			}}
		/>
	) : null;
};
